var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g2, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g3, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoEntityFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 304,
    viewBox: "0 0 581 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12755_546338)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.056 119.972C316.556 119.939 323.046 119.449 329.478 118.505C332.35 118.091 338.594 114.908 339.714 115.686C340.835 116.463 341.559 118.602 334.979 120.11C337.875 119.912 346.589 117.691 349.084 118.868C351.173 119.852 352.888 123.702 347.327 125.358C344.229 126.277 328.085 129.244 310.056 129.442",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.056 119.972C316.556 119.939 323.046 119.449 329.478 118.505C332.35 118.091 338.594 114.908 339.714 115.686C340.835 116.463 341.559 118.602 334.979 120.11C337.875 119.912 346.589 117.691 349.084 118.868C351.173 119.852 352.888 123.702 347.327 125.358C344.229 126.277 328.085 129.244 310.056 129.442",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.022 96.1338C383.983 83.9322 382.3 69.883 373.263 64.7541C364.225 59.6252 351.256 65.3588 344.295 77.5605C337.334 89.7622 339.018 103.811 348.055 108.94C357.092 114.069 370.062 108.336 377.022 96.1338Z",
    fill: "#00689B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.669 105.379C354.659 105.398 352.679 104.889 350.929 103.903C347.503 101.962 345.312 98.3472 344.759 93.7298C344.206 89.1123 345.335 84.1544 347.922 79.6197C351.837 72.7533 358.403 68.3152 364.647 68.3152C366.657 68.2967 368.637 68.8058 370.387 69.7915C373.814 71.7369 376.004 75.3472 376.557 79.9647C377.11 84.5822 375.981 89.54 373.394 94.0747C369.474 100.941 362.894 105.379 356.669 105.379Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364.647 68.775C366.584 68.7543 368.492 69.2429 370.18 70.1915C376.995 74.0593 378.263 84.651 373.016 93.8492C369.073 100.748 362.572 104.919 356.693 104.919C354.755 104.94 352.847 104.451 351.159 103.503C344.349 99.6395 343.076 89.0478 348.328 79.8496C352.27 72.951 358.772 68.775 364.651 68.775H364.647ZM364.651 67.8552C358.246 67.8552 351.528 72.3853 347.53 79.3943C344.893 83.9934 343.749 89.1214 344.302 93.7848C344.874 98.5495 347.148 102.284 350.703 104.303C352.53 105.333 354.598 105.863 356.697 105.839C363.102 105.839 369.82 101.314 373.823 94.3045C376.456 89.6825 377.599 84.5729 377.051 79.9094C376.479 75.1447 374.206 71.4103 370.65 69.3913C368.831 68.367 366.773 67.8374 364.684 67.8552H364.651Z",
    fill: "#1D1E26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.973 111.246L343.587 107.176L342.891 108.432L350.277 112.502L350.973 111.246Z",
    fill: "#1D1E26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M337.132 133.93C335.777 134.556 332.203 132.504 331.889 131.042C330.903 126.401 344.496 109.284 344.496 109.284L348.692 111.583C348.692 111.583 341.181 132.063 337.132 133.93Z",
    fill: "#008ACE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M331.696 141.533C334.011 141.533 335.887 139.661 335.887 137.352C335.887 135.043 334.011 133.171 331.696 133.171C329.381 133.171 327.504 135.043 327.504 137.352C327.504 139.661 329.381 141.533 331.696 141.533Z",
    fill: "#008ACE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.725 133.691C334.519 134.129 335.149 134.814 335.518 135.641L336.404 134.041C334.974 133.972 332.747 132.661 332.069 131.484L331.115 133.213C332.014 133.087 332.929 133.254 333.725 133.691Z",
    fill: "#1D1E26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.056 119.972C316.556 119.939 323.046 119.449 329.478 118.505C332.35 118.091 338.594 114.908 339.714 115.686C340.835 116.463 341.559 118.602 334.979 120.11",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M310.056 119.972C316.556 119.939 323.046 119.449 329.478 118.505C332.35 118.091 338.594 114.908 339.714 115.686C340.835 116.463 341.559 118.602 334.979 120.11",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.494 71.5713C280.494 71.5713 282.657 73.8432 282.177 80.5533C281.697 87.2633 285.331 108.516 288.503 111.68C291.676 114.844 295.752 117.553 320.228 116.652C320.689 119.365 322.497 132.472 322.497 132.472C322.497 132.472 295.752 133.392 289.864 131.553C283.975 129.713 274.403 133.595 269.441 91.6601C267.68 85.5663 277.017 71.2493 280.494 71.5713Z",
    fill: "#1D1E26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.446 178.201C171.446 178.201 215.754 199.141 277.852 170.222C276.04 162.987 255.64 94.2815 288.278 60.8185C279.664 54.9455 261.994 40.4767 252.924 44.0916C243.854 47.7065 190.374 77.0947 171.446 178.201Z",
    fill: "#00689B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.197 74.3813C284.197 74.3813 288.683 109.601 290.993 111.905C295.074 115.971 316.355 115.069 316.355 115.069L317.738 134.054C317.738 134.054 285.105 136.317 279.664 129.989C274.753 124.272 269.695 114.163 271.05 106.028C272.406 97.8918 279.664 72.1231 284.197 74.3813Z",
    fill: "#008ACE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12755_546338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 74,
    width: 48,
    height: 61
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M284.197 74.3813C284.197 74.3813 288.683 109.601 290.993 111.905C295.074 115.971 316.355 115.069 316.355 115.069L317.738 134.054C317.738 134.054 285.105 136.317 279.664 129.989C274.753 124.272 269.695 114.163 271.05 106.028C272.406 97.8918 279.664 72.1231 284.197 74.3813Z",
    fill: "#008ACE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12755_546338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.291 23.5798V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.713 23.5798V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.136 23.5798V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7341 85.5754H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7341 110.374H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7341 97.9746H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.291 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.713 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.136 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7341 110.374H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7341 122.778H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.277 60.8186C288.277 60.8186 295.983 70.7664 295.983 75.738C293.262 75.2781 285.557 73.4799 284.197 75.738C282.836 77.9962 269.695 111.45 271.05 134.961C269.238 127.726 263.345 68.0668 288.277 60.8186Z",
    fill: "#00689B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.104 58.1926C277.377 60.3976 279.183 62.2504 281.356 63.5828C293.714 69.5892 303.572 54.7755 307.432 48.8657C307.432 48.8657 318.176 33.7393 302.281 23.7914C286.751 14.0644 279.894 29.853 280.19 29.4345C282.112 31.3431 282.149 34.8339 282.149 34.8339C282.149 34.8339 281.485 27.5949 275.966 28.6619C272.858 29.2598 270.317 33.5783 270.834 36.6965C271.007 37.7339 271.464 38.7033 272.155 39.4979C272.846 40.2924 273.743 40.8811 274.748 41.199C274.841 41.2269 274.926 41.2734 275 41.3354C275.074 41.3975 275.134 41.4739 275.177 41.56C275.22 41.6461 275.246 41.74 275.251 41.8361C275.257 41.9322 275.243 42.0284 275.21 42.1188C272.023 49.2888 273.121 53.8925 273.121 53.8925C273.121 53.8925 270.787 58.7077 264.101 62.7043C264.101 62.7043 263.917 67.5702 269.635 71.0747C275.744 74.8275 276.847 71.7461 276.847 71.7461C277.441 68.6158 279.021 65.7561 281.356 63.5828C293.714 69.5892 303.572 54.7755 307.432 48.8657",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M276.104 58.1926C277.377 60.3976 279.183 62.2504 281.356 63.5828C293.714 69.5892 303.572 54.7755 307.432 48.8657C307.432 48.8657 318.176 33.7393 302.281 23.7914C286.751 14.0644 279.894 29.853 280.19 29.4345C282.112 31.3431 282.149 34.8339 282.149 34.8339C282.149 34.8339 281.485 27.5949 275.966 28.6619C272.858 29.2598 270.317 33.5783 270.834 36.6965C271.007 37.7339 271.464 38.7033 272.155 39.4979C272.846 40.2924 273.743 40.8811 274.748 41.199C274.841 41.2269 274.926 41.2734 275 41.3354C275.074 41.3975 275.134 41.4739 275.177 41.56C275.22 41.6461 275.246 41.74 275.251 41.8361C275.257 41.9322 275.243 42.0284 275.21 42.1188C272.023 49.2888 273.121 53.8925 273.121 53.8925C273.121 53.8925 270.787 58.7077 264.101 62.7043C264.101 62.7043 263.917 67.5702 269.635 71.0747C275.744 74.8275 276.847 71.7461 276.847 71.7461C277.441 68.6158 279.021 65.7561 281.356 63.5828C293.714 69.5892 303.572 54.7755 307.432 48.8657",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M277.972 31.803C277.972 31.803 280.134 33.9645 278.336 37.1195",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M289.177 47.2603C289.841 47.2603 290.38 46.7229 290.38 46.06C290.38 45.397 289.841 44.8596 289.177 44.8596C288.512 44.8596 287.973 45.397 287.973 46.06C287.973 46.7229 288.512 47.2603 289.177 47.2603Z",
    fill: "#1D1E26"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.307 55.1893C298.933 55.1893 299.441 54.6827 299.441 54.0579C299.441 53.433 298.933 52.9265 298.307 52.9265C297.68 52.9265 297.172 53.433 297.172 54.0579C297.172 54.6827 297.68 55.1893 298.307 55.1893Z",
    fill: "#1D1E26"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M294.857 49.2104C294.857 49.2104 290.329 57.7969 289.094 58.4454C287.858 59.0939 286.894 56.6794 286.894 56.6794",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M280.024 54.9778C280.024 54.9778 278.124 57.8798 282.135 59.4067",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M295.855 40.9481C295.97 39.9667 294.096 38.9424 291.671 38.6604C289.245 38.3783 287.185 38.9452 287.071 39.9266C286.956 40.908 288.829 41.9323 291.255 42.2144C293.681 42.4965 295.741 41.9296 295.855 40.9481Z",
    fill: "#1D1E26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.913 55.2002C305.698 54.597 305.263 52.7218 303.941 51.0119C302.619 49.3021 300.912 48.405 300.127 49.0083C299.343 49.6115 299.778 51.4867 301.1 53.1966C302.421 54.9064 304.129 55.8035 304.913 55.2002Z",
    fill: "#1D1E26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M278.811 35.2799C278.267 34.5799 277.487 34.101 276.616 33.9324",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M279.968 41.0057C281.107 41.4656 286.078 30.9337 292.57 35.4362C299.063 39.9387 304.098 52.9128 319.121 50.1533C334.144 47.3938 331.414 29.5402 324.286 25.8931C329.155 25.7551 333.738 0.685503 302.95 9.16622C301.23 0.887863 286.599 -2.8374 280.817 2.46075C274.057 8.66952 279.728 14.3632 279.728 14.3632C279.728 14.3632 261.491 16.0603 261.478 32.9849C261.478 49.3669 272.747 53.4049 272.747 53.4049C272.747 53.4049 272.033 49.2979 274.859 41.8749C274.891 41.7844 274.904 41.6885 274.898 41.5928C274.892 41.4972 274.866 41.4037 274.823 41.3179C274.78 41.2322 274.72 41.1559 274.647 41.0936C274.574 41.0313 274.49 40.9842 274.398 40.9551C273.394 40.6361 272.498 40.0469 271.808 39.2525C271.118 38.4581 270.661 37.4893 270.488 36.4526C269.967 33.3344 272.494 28.9377 275.615 28.418C278.737 27.8983 281.965 30.9613 281.799 34.5716C281.684 36.6872 277.372 40.0123 279.968 41.0057Z",
    fill: "#1D1E26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M302.95 9.16626C302.927 9.20305 303.692 16.0649 300.723 13.6182C298.251 11.5854 302.95 9.16626 302.95 9.16626Z",
    stroke: "white",
    strokeWidth: 0.461111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M279.696 14.4092C279.733 14.4322 282.214 20.8801 283.726 17.348C284.981 14.4046 279.696 14.4092 279.696 14.4092Z",
    stroke: "white",
    strokeWidth: 0.461111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M324.571 26.0128C324.53 26.0128 319.582 30.644 318.78 26.8866C318.245 24.3755 324.571 26.0128 324.571 26.0128Z",
    stroke: "white",
    strokeWidth: 0.461111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M294.862 33.4126C294.862 33.4126 303.798 43.9261 310.106 46.1889C317.867 48.9759 323.147 46.5016 326.476 41.2678",
    stroke: "white",
    strokeWidth: 0.461111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.956 245.518L158.94 237.46L171.446 244.971L165.539 254.095L162.652 252.44C159.639 251.613 157.003 249.774 155.192 247.233L153.956 245.518Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.441 296.347C242.923 284.035 241.59 242.998 214.394 253.856C167.443 272.588 106.517 266.062 99.7245 200.521C92.9324 134.979 25.4349 122.023 27.6667 158.016C29.4789 187.399 59.8476 184.231 69.8169 175.193C79.7861 166.156 110.879 122.488 78.8823 109.192C51.6767 97.8919 6.81524 117.783 0.493408 80.7097",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.69 3.69"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M559.208 272.841H30.4334C25.3612 272.841 21.2527 276.281 21.2527 280.526C21.2527 284.771 25.3612 288.211 30.4334 288.211H95.7682C90.696 288.211 86.5921 291.651 86.5921 295.896C86.5921 300.141 90.7006 303.581 95.7682 303.581H500.476C505.548 303.581 509.652 300.141 509.652 295.896C509.652 291.651 505.544 288.211 500.476 288.211H559.208C564.28 288.211 568.384 284.771 568.384 280.526C568.384 276.281 564.276 272.841 559.208 272.841Z",
    fill: "#F5F6FA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M259.721 241.65V252.499L273.872 252.398L274.679 239.387L259.721 241.65Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8335 270.381L79.7723 271.954L81.483 269.075C80.7666 266.655 79.7911 264.319 78.5734 262.107L76.1664 264.521L77.7434 260.672C76.2979 258.285 74.5583 256.088 72.5651 254.132L70.2596 257.122L71.3801 253.051C69.4922 251.386 67.3798 249.993 65.1044 248.912L64.6432 251.432C64.6432 251.432 64.3666 249.827 64.0853 248.457C61.7338 247.48 59.2453 246.87 56.7075 246.649C56.7433 249.961 57.0969 253.261 57.7635 256.505C59.1145 257.269 60.5301 258.101 60.5301 258.101L58.0355 257.839C58.6945 260.788 59.67 263.657 60.9451 266.398C62.536 266.798 64.6801 267.249 64.6801 267.249L61.48 267.47C62.9114 270.307 64.8597 272.854 67.2255 274.98L70.859 274.934L68.4382 275.964C71.8458 278.53 76.2494 280.2 81.9257 280.255C82.8571 277.896 82.811 274.327 81.8335 270.381Z",
    fill: "white",
    stroke: "#9BDEFF",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6982 246.658L81.9302 280.264",
    stroke: "#9BDEFF",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2388 272.611L86.4721 272.239L89.972 271.319C91.3034 268.854 92.3758 266.259 93.1721 263.574L89.5108 263.606L93.6608 261.803C94.4235 258.805 94.8199 255.726 94.8413 252.633L90.8388 253.189L94.8182 250.857C94.6918 248.093 94.186 245.358 93.315 242.731L91.0095 244.345C91.0095 244.345 92.0423 242.864 92.8908 241.586C91.8964 239.006 90.5107 236.594 88.7823 234.434C86.2484 237.076 83.9668 239.947 81.9671 243.011C82.3867 244.658 82.8109 246.424 82.8109 246.424L81.1555 244.262C79.3672 247.099 77.8805 250.114 76.7196 253.258C77.6003 254.803 78.8546 256.827 78.8546 256.827L76.2908 254.528C75.1707 257.87 74.6616 261.386 74.7876 264.908L77.5312 267.667L74.9305 266.596C75.4931 271.268 77.4897 276.001 81.6904 280.457C84.2035 279.312 86.924 276.474 89.2388 272.611Z",
    fill: "#008ACE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7777 234.416L81.6904 280.462",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M221.873 163.668C221.873 163.668 214.624 190.803 206.919 206.159C201.243 217.482 172.455 247.753 172.455 247.753L154.795 237.355C154.795 237.355 178.814 206.159 180.156 199.831C181.498 193.502 181.078 159.598 188.313 148.749C195.548 137.899 201.044 127.501 201.044 127.501C201.044 127.501 215.094 136.543 245.463 132.022C249.088 139.256 257.475 147.166 263.364 154.852C269.252 162.537 285.557 186.364 287.613 191.244C291.242 199.831 275.827 242.326 275.827 242.326H259.495C259.495 242.326 257.226 205.708 261.307 198.474C257.683 195.765 230.938 179.038 221.873 163.668Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M199.472 57.098C199.472 57.098 179.529 58.9055 153.241 83.3128C151.115 85.2858 147.805 91.4532 146.444 91.4532C145.084 91.4532 143.272 90.0735 147.828 85.1249C145.559 86.9323 139.666 93.7114 136.95 94.1667C134.667 94.5438 131.057 92.3546 134.681 87.8337C138.306 83.3128 172.755 49.4084 200.809 45.9084",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M199.472 57.098C199.472 57.098 179.529 58.9055 153.241 83.3128C151.115 85.2858 147.805 91.4532 146.444 91.4532C145.084 91.4532 143.272 90.0735 147.828 85.1249C145.559 86.9323 139.666 93.7114 136.95 94.1667C134.667 94.5438 131.057 92.3546 134.681 87.8337C138.306 83.3128 172.755 49.4084 200.809 45.9084",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.219 70.3159L159.083 80.7098C159.083 80.7098 194.437 51.3262 221.633 58.5606C227.526 60.368 207.131 100.601 200.786 127.726C200.786 129.534 221.633 145.81 245.657 132.247C282.371 83.4233 280.558 71.668 280.558 71.668C280.558 71.668 265.148 69.4098 264.24 57.2039C260.159 47.2606 248.497 35.7721 205.771 41.383C171.335 45.9039 148.219 70.3159 148.219 70.3159Z",
    fill: "#1D1E26"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M153.209 63.0811L163.178 78.902C162.837 79.0262 204.876 51.3075 218.475 61.7244C218.475 61.7244 215.118 75.9816 183.573 101.957C173.152 110.548 138.251 127.712 125.104 129.552C126.026 133.622 155.473 180.638 160.458 185.159C164.99 181.977 223.459 148.091 235.245 120.956C247.031 93.8214 260.629 73.9396 276.04 65.3485C275.579 62.6396 269.695 38.2139 262.893 34.1575C260.173 36.4156 252.924 43.1993 252.924 43.1993C252.924 43.1993 212.572 21.4916 153.209 63.0811Z",
    fill: "#008ACE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12755_546338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 34,
    width: 152,
    height: 152
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M153.209 63.0811L163.178 78.902C162.837 79.0262 204.876 51.3075 218.475 61.7244C218.475 61.7244 215.118 75.9816 183.573 101.957C173.152 110.548 138.251 127.712 125.104 129.552C126.026 133.622 155.473 180.638 160.458 185.159C164.99 181.977 223.459 148.091 235.245 120.956C247.031 93.8214 260.629 73.9396 276.04 65.3485C275.579 62.6396 269.695 38.2139 262.893 34.1575C260.173 36.4156 252.924 43.1993 252.924 43.1993C252.924 43.1993 212.572 21.4916 153.209 63.0811Z",
    fill: "#008ACE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12755_546338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.634 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.057 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.479 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.903 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.325 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.749 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.176 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.599 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.022 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.445 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.868 23.5796V110.374",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 35.9788H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 48.3779H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 60.7771H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 73.1763H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 85.5754H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 110.374H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 97.9746H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.634 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.057 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.479 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.903 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.325 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.748 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.176 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.599 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.022 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.445 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.868 110.374V197.172",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 110.374H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 122.778H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 135.177H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 147.576H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 159.975H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 172.374H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7344 184.773H372.55",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M523.753 277.951C523.753 277.951 526.271 270.326 529.554 267.373C529.905 268.118 530.354 268.813 530.891 269.438L531.454 266.168C531.454 266.168 538.011 259.108 543.018 258.763C543.357 260.282 543.941 261.736 544.747 263.068L545.956 257.549C545.956 257.549 553.55 254.62 557.022 255.31C557.193 256.514 557.539 258.239 557.714 259.789C558.576 258.409 560.13 255.65 560.13 255.65C560.13 255.65 565.663 256.51 567.9 258.579C567.9 260.47 564.1 266.858 562.03 268.564C560.647 268.049 557.714 267.704 557.714 267.704L560.992 270.804C560.992 270.804 555.796 276.865 554.256 276.865C553.218 276.521 549.94 275.145 549.94 275.145L551.494 278.07C551.494 278.07 547.477 280.085 523.753 277.951Z",
    fill: "white",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M567.881 258.616C567.881 258.616 533.349 276.35 523.684 278.07",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M562.182 257.926L560.056 262.544",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M551.825 258.616L549.405 267.699",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M539.564 263.606L537.365 273.163",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M545.089 276.35L535.691 273.876",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M555.45 272.39L547.21 268.729",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M563.219 263.606L558.811 263.156",
    stroke: "#00689B",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M542.502 251.078C542.502 251.078 542.156 248.498 538.878 248.498C537.716 248.498 539.394 239.544 541.294 240.404C543.194 241.264 541.294 244.193 541.294 244.193C541.294 244.193 545.61 237.295 547.851 239.544C549.552 241.241 544.918 246.948 544.918 246.948C544.918 246.948 547.685 245.224 548.372 246.258C549.059 247.293 547.51 249.358 542.502 251.078Z",
    fill: "#1D1E26"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M518.676 244.538C518.676 244.538 515.739 242.299 512.977 245.568C511.944 243.848 509.698 239.369 511.252 238.339C512.806 237.309 514.019 240.404 514.019 240.404C514.019 240.404 512.119 232.829 514.881 232.654C517.643 232.479 516.956 239.714 516.956 239.714C516.956 239.714 518.851 234.379 520.581 235.754C522.31 237.129 518.676 244.538 518.676 244.538Z",
    fill: "#1D1E26"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M536.111 226.455C536.111 226.455 534.216 223.53 531.624 224.735C530.933 223.355 530.07 215.076 532.486 216.125C534.903 217.174 533.506 220.756 533.506 220.756C533.506 220.756 535.751 212.837 537.992 214.387C540.233 215.936 536.092 221.616 536.092 221.616C536.092 221.616 538.859 217.827 540.413 218.857C541.967 219.887 539.91 223.516 536.111 226.455Z",
    fill: "#1D1E26"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M525.524 278.705C525.524 278.705 543.212 254.555 540.455 251.239C537.951 248.227 532.256 252.702 527.082 261.486C532.085 251.152 538.647 229.113 532.777 227.218C526.907 225.323 521.383 254.767 521.71 258.211C520.502 248.397 517.809 244.198 514.794 247.174C512.027 249.933 513.973 271.903 515.227 278.687L525.524 278.705Z",
    fill: "#9BDEFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12755_546338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 513,
    y: 227,
    width: 28,
    height: 52
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M525.524 278.705C525.524 278.705 543.212 254.555 540.455 251.239C537.951 248.227 532.256 252.702 527.082 261.486C532.085 251.152 538.647 229.113 532.777 227.218C526.907 225.323 521.383 254.767 521.71 258.211C520.502 248.397 517.809 244.198 514.794 247.174C512.027 249.933 513.973 271.903 515.227 278.687L525.524 278.705Z",
    fill: "#9BDEFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12755_546338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.7 264.618L520.47 285.627",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.501 235.175L513.964 289.757",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.979 272.538L511.571 226.045",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.455 248.434L520.47 289.757",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.853 241.374L545.979 279.597",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.454 228.115L478.527 278.047",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.439 289.757L539.472 224.496",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.418 223.465L488.455 257.903",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.728 254.629L477.328 283.902",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.548 227.08L528.862 301.125",
    stroke: "white",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M580.17 205.934C580.17 205.934 561.131 134.054 521.245 156.659C491.457 173.542 523.965 195.535 535.751 185.141C551.503 171.243 522.946 138.184 497.677 141.74C462.324 146.711 462.776 200.52 489.068 224.923C514.001 248.075 504.091 294.572 467.765 279.192C449.634 271.507 468.687 258.4 479.546 271.507C487.763 281.409 465.054 303.572 439.208 293.661",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.69 3.69"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M258.983 251.216L258.743 270.661C258.743 270.661 270.396 268.362 278.682 270.137C286.968 271.912 298.39 272.105 300.967 270.726C300.243 268.215 298.127 263.091 285.082 259.725C280.471 257.765 275.578 250.448 275.578 250.448L258.983 251.216Z",
    fill: "#9BDEFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M300.967 270.726C298.39 272.105 286.968 271.894 278.682 270.137C270.396 268.38 258.743 270.661 258.743 270.661L258.96 271.774C259.164 272.668 259.677 273.462 260.408 274.016C261.14 274.57 262.045 274.849 262.962 274.805L299.455 273.136C299.686 273.136 299.915 273.087 300.126 272.991C300.337 272.895 300.525 272.755 300.677 272.581C300.828 272.406 300.941 272.201 301.006 271.979C301.071 271.758 301.088 271.525 301.055 271.296L300.967 270.726Z",
    fill: "#1D1E26"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M259.504 262.788C259.504 262.788 268.265 261.767 270.843 269.475",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M273.494 255.645C274.037 255.645 274.476 255.207 274.476 254.666C274.476 254.125 274.037 253.686 273.494 253.686C272.952 253.686 272.512 254.125 272.512 254.666C272.512 255.207 272.952 255.645 273.494 255.645Z",
    fill: "#1D1E26"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M276.906 259.43C277.449 259.43 277.889 258.992 277.889 258.451C277.889 257.91 277.449 257.471 276.906 257.471C276.364 257.471 275.924 257.91 275.924 258.451C275.924 258.992 276.364 259.43 276.906 259.43Z",
    fill: "#1D1E26"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M281.181 262.323C281.723 262.323 282.163 261.884 282.163 261.343C282.163 260.802 281.723 260.364 281.181 260.364C280.638 260.364 280.199 260.802 280.199 261.343C280.199 261.884 280.638 262.323 281.181 262.323Z",
    fill: "#1D1E26"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M273.752 254.574C273.752 254.574 277.607 253.571 277.672 252.605",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M276.906 258.469C276.906 258.469 281.103 256.924 280.734 255.88",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M281.181 261.343C281.181 261.343 284.699 260.345 284.141 258.782",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M410.2 238.937C410.2 238.937 421.363 239.3 424.706 247.072C426.062 250.237 418.813 262.443 418.813 262.443L426.989 269.677C426.989 269.677 431.522 265.156 426.989 260.635C429.258 257.922 435.603 245.265 429.71 238.486C425.297 233.427 418.375 226.28 418.375 226.28L410.2 238.937Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M385.272 223.566C376.659 234.866 353.543 243.908 350.823 246.622C348.102 249.335 344.934 260.635 344.478 266.963C349.467 267.423 350.371 272.39 350.371 272.39H338.585C338.585 272.39 336.773 248.429 337.229 245.256C337.686 242.082 354.452 226.721 357.624 212.708L385.272 223.566Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M344.528 200.907C344.528 200.907 335.172 194.399 340.056 184.148C340.093 184.074 340.103 183.99 340.084 183.91C340.065 183.83 340.02 183.758 339.954 183.708C339.889 183.658 339.808 183.633 339.725 183.635C339.643 183.638 339.564 183.67 339.502 183.725C331.756 190.623 325.471 200.194 334.79 210.859C338.529 206.812 344.528 200.907 344.528 200.907Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3 239.387C434.676 231.702 423.346 229.895 420.174 229.895C413.824 238.937 404.763 240.293 401.586 241.65C398.409 243.007 397.962 247.072 396.15 251.143C394.338 255.213 393.881 269.677 394.338 273.292C399.322 273.747 399.783 279.165 399.783 279.165H388.445C388.445 279.165 386.176 243.904 385.272 239.833C384.368 235.763 386.656 234.411 386.656 234.411C386.656 234.411 362.18 228.984 359.911 231.698C351.302 242.998 328.187 252.039 325.466 254.753C322.745 257.466 319.55 268.771 319.089 275.099C324.073 275.559 324.982 280.526 324.982 280.526H313.205C313.205 280.526 311.393 256.565 311.822 253.392C312.251 250.218 329.044 234.857 332.217 220.844C335.389 206.83 338.133 201.413 344.478 200.98C350.823 200.548 394.789 200.061 405.667 196.459C416.545 192.858 425.61 199.173 433.334 205.952C442.229 213.77 451.188 216.99 457.109 220.738C460.461 222.854 465.515 227.637 465.063 234.434C464.611 241.232 466.446 249.804 471.408 254.776C471.408 256.583 465.967 261.104 460.078 259.297C454.19 257.489 441.472 243.908 438.3 239.387Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M461.277 237.037C461.182 237.172 461.053 237.281 460.904 237.353C460.755 237.425 460.59 237.458 460.424 237.448C460.259 237.439 460.098 237.388 459.958 237.3C459.818 237.212 459.702 237.09 459.622 236.945C459.542 236.801 459.501 236.638 459.501 236.473C459.501 236.307 459.544 236.145 459.625 236.001C459.705 235.856 459.821 235.735 459.962 235.647C460.103 235.56 460.263 235.51 460.429 235.501C460.183 235.295 459.89 235.151 459.576 235.083C458.308 234.807 457.003 235.869 456.661 237.451C456.32 239.033 457.067 240.537 458.335 240.809C459.603 241.08 460.913 240.022 461.254 238.44C461.356 237.979 461.364 237.502 461.277 237.037Z",
    fill: "#1D1E26"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M458.926 253.176C458.926 253.176 458.243 254.758 462.55 256.34",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M454.522 223.709C453.185 221.998 450.058 219.151 446.508 221.506C442.957 223.861 436.631 237.051 436.894 246.01C437.156 254.969 444.534 259.228 448.841 259.559C453.148 259.89 453.992 255.227 453.526 248.88C453.06 242.533 457.15 227.066 454.522 223.709Z",
    fill: "#1D1E26"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M445.553 214.074C445.553 214.074 433.993 222.706 435.33 236.15C433.989 236.15 429.645 236.196 429.645 236.196C429.645 236.196 428.783 219.478 440.569 210.901L445.553 214.074Z",
    fill: "#008ACE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M431.729 241.65C434.108 241.65 436.036 239.727 436.036 237.355C436.036 234.982 434.108 233.059 431.729 233.059C429.351 233.059 427.422 234.982 427.422 237.355C427.422 239.727 429.351 241.65 431.729 241.65Z",
    fill: "#008ACE"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M467.912 249.942C467.912 249.942 468.42 253.47 468.332 255.038C468.198 257.522 467.843 257.439 468.752 258.345C469.66 259.251 472.759 258.064 472.902 255.585C473.1 251.97 469.983 248.558 467.912 249.942Z",
    fill: "#1D1E26"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M344.51 201.44C341.038 201.689 338.654 203.45 336.583 207.999C338.995 209.737 342.785 210.464 344.478 208.215C347.198 204.595 346.746 209.135 354.903 210.924C362.12 212.524 362.424 203.032 362.397 200.806C359.072 200.921 355.973 201.017 353.28 201.105C348.987 201.229 345.889 201.321 344.51 201.44Z",
    fill: "#F5F6FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.579 251.258C314.893 251.345 316.636 250.798 318.651 249.786C323.184 247.523 323.184 245.716 327.716 247.523C332.249 249.331 334.518 243.908 334.518 240.744C334.518 237.58 339.502 234.416 334.518 230.346C333.065 229.164 331.119 229.288 329.081 230.047C325.637 236.389 320.726 242.4 317.092 246.865C315.709 248.521 314.478 250.053 313.579 251.258Z",
    fill: "#F5F6FA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M405.815 196.878C403.721 197.573 400.438 198.152 396.445 198.635C394.43 203.694 392.226 211.209 397.058 210.905C404.307 210.445 408.84 209.553 410.2 212.717C411.56 215.882 408.388 224.468 415.184 223.567C421.981 222.665 429.235 217.689 427.422 212.717C426.187 209.328 426.851 204.899 428.686 202.696C421.917 197.504 414.465 194.004 405.815 196.878Z",
    fill: "#F5F6FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M372.951 231.376C373.482 230.771 373.965 230.125 374.395 229.444C375.755 227.181 380.739 227.632 385.272 230.364C389.805 233.096 391.617 232.627 394.338 230.364C397.058 228.101 391.617 225.843 388.897 223.585C386.176 221.327 382.1 217.707 376.659 217.707C371.218 217.707 368.05 218.167 366.233 222.228C366.233 222.228 361.248 224.036 359.436 226.298C358.514 227.448 359.238 229.187 360.589 230.851C362.867 230.166 367.87 230.617 372.951 231.376Z",
    fill: "#F5F6FA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M390.257 254.758C389.796 250.237 391.179 247.073 390.257 243.908C389.703 241.972 388.126 242.745 386.264 243.95C386.872 250.191 387.707 261.468 388.256 269.594C389.311 268.389 390.354 266.835 391.608 265.607C394.789 262.443 390.709 259.279 390.257 254.758Z",
    fill: "#F5F6FA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M345.833 268.771C345.833 268.771 348.554 270.151 348.844 272.39",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344.478 270.578C344.478 270.578 346.064 270.887 346.29 272.381",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M320.472 276.911C320.472 276.911 323.022 277.785 323.354 280.209",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M318.969 278.411C318.969 278.411 320.703 278.705 320.781 280.209",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M394.891 275.398C394.891 275.398 397.612 276.318 397.778 279.156",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M393.406 276.897C393.406 276.897 395.218 277.357 395.218 279.156",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M426.38 263.068C426.819 263.905 427.008 264.85 426.926 265.791C426.845 266.732 426.495 267.63 425.919 268.38",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M424.019 263.284C424.341 263.776 424.493 264.358 424.454 264.944C424.415 265.53 424.187 266.087 423.803 266.531",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M426.989 249.786C426.971 249.587 426.915 249.393 426.822 249.216C426.729 249.038 426.603 248.881 426.449 248.753C426.295 248.625 426.117 248.528 425.926 248.468C425.734 248.409 425.533 248.388 425.333 248.406C425.158 251.234 422.903 255.967 421.183 259.237C423.766 259.416 426.025 257.397 424.287 255.686C421.986 253.41 427.422 252.95 426.989 249.786Z",
    fill: "#F5F6FA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M345.197 259.701C345.782 257.1 346.531 254.538 347.438 252.03C345.736 252.03 343.892 251.906 341.305 252.95C338.456 254.095 342.117 257.42 345.197 259.701Z",
    fill: "#F5F6FA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M332.696 199.601C330.88 197.342 335.412 195.986 335.869 191.916C335.924 191.44 335.835 190.959 335.614 190.535C335.393 190.11 335.05 189.761 334.628 189.533C329.713 195.972 329.256 202.075 333.245 208.058C337.718 206.357 334.232 201.523 332.696 199.601Z",
    fill: "#F5F6FA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M153.933 244.134C153.933 244.134 158.719 251.216 166.844 253.084C158.11 269.102 155.51 279.625 151.706 283.304C148.718 286.188 138.841 288.363 135.382 276.64C133.34 269.696 139.588 263.386 141.137 261.077C142.686 258.768 142.672 253.87 144.637 251.571C146.601 249.271 150.276 244.851 153.933 244.134Z",
    fill: "#9BDEFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M135.368 276.659C135.474 277.008 135.58 277.344 135.696 277.67C135.733 277.781 135.774 277.877 135.816 277.983C135.894 278.199 135.972 278.411 136.055 278.613L136.208 278.958C136.286 279.137 136.364 279.317 136.447 279.487C136.53 279.657 136.563 279.712 136.618 279.827L136.867 280.287C136.927 280.398 136.991 280.503 137.051 280.609L137.314 281.028L137.508 281.322L137.785 281.708L137.987 281.975C138.084 282.095 138.181 282.21 138.283 282.325C138.384 282.44 138.416 282.486 138.485 282.559C138.555 282.633 138.698 282.785 138.808 282.895C138.919 283.005 138.933 283.028 139.002 283.088C139.071 283.148 139.256 283.323 139.385 283.433C139.435 283.474 139.481 283.52 139.532 283.557C139.712 283.704 139.892 283.847 140.076 283.976L140.196 284.054C140.339 284.15 140.487 284.247 140.634 284.334L140.842 284.454L141.206 284.647L141.441 284.758L141.782 284.914L142.031 285.006C142.142 285.052 142.253 285.093 142.368 285.13L142.617 285.208L142.958 285.305L143.207 285.365L143.548 285.438L143.797 285.48L144.148 285.53L144.383 285.558C144.508 285.558 144.632 285.558 144.757 285.585H144.964C145.121 285.585 145.273 285.585 145.425 285.585H145.54C145.73 285.585 145.919 285.585 146.108 285.558H146.283C146.412 285.558 146.536 285.558 146.666 285.516L146.882 285.484C146.993 285.484 147.104 285.452 147.21 285.429L147.436 285.383L147.745 285.319L147.971 285.259L148.256 285.181L148.478 285.112L148.754 285.02L148.967 284.941L149.234 284.836L149.432 284.758L149.7 284.638L149.875 284.555L150.147 284.413L150.29 284.334C150.424 284.261 150.548 284.187 150.668 284.109C146.518 285.116 140.754 283.838 138.287 275.454C136.24 268.509 142.488 262.204 144.042 259.895C145.499 257.719 144.697 251.897 150.253 245.95C147.947 247.657 145.923 250.09 144.627 251.593C142.663 253.852 142.663 258.791 141.114 261.1C140.339 262.254 138.389 264.411 136.89 267.143C136.504 267.838 136.164 268.557 135.871 269.295C134.877 271.623 134.7 274.218 135.368 276.659Z",
    fill: "#1D1E26"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M148.676 247.979C148.676 247.979 150.686 253.497 144.143 256.565",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M154.74 254.298C155.282 254.298 155.722 253.859 155.722 253.318C155.722 252.777 155.282 252.338 154.74 252.338C154.197 252.338 153.758 252.777 153.758 253.318C153.758 253.859 154.197 254.298 154.74 254.298Z",
    fill: "#1D1E26"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M151.438 259.996C151.981 259.996 152.42 259.557 152.42 259.016C152.42 258.475 151.981 258.037 151.438 258.037C150.896 258.037 150.456 258.475 150.456 259.016C150.456 259.557 150.896 259.996 151.438 259.996Z",
    fill: "#1D1E26"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M147.97 265.483C148.513 265.483 148.953 265.044 148.953 264.503C148.953 263.962 148.513 263.523 147.97 263.523C147.428 263.523 146.988 263.962 146.988 264.503C146.988 265.044 147.428 265.483 147.97 265.483Z",
    fill: "#1D1E26"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M160.458 257.591C161 257.591 161.44 257.152 161.44 256.611C161.44 256.07 161 255.631 160.458 255.631C159.915 255.631 159.475 256.07 159.475 256.611C159.475 257.152 159.915 257.591 160.458 257.591Z",
    fill: "#1D1E26"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M157.423 262.732C157.966 262.732 158.406 262.294 158.406 261.753C158.406 261.212 157.966 260.773 157.423 260.773C156.881 260.773 156.441 261.212 156.441 261.753C156.441 262.294 156.881 262.732 157.423 262.732Z",
    fill: "#1D1E26"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.343 268.265C154.885 268.265 155.325 267.827 155.325 267.286C155.325 266.744 154.885 266.306 154.343 266.306C153.801 266.306 153.361 266.744 153.361 267.286C153.361 267.827 153.801 268.265 154.343 268.265Z",
    fill: "#1D1E26"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M154.933 253.534C154.592 253.097 156.095 256.841 160.467 256.611",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M151.438 259.016C151.438 259.016 153.721 262.861 157.433 261.753",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M147.97 264.503C147.97 264.503 150.299 267.957 154.343 267.263",
    stroke: "#1D1E26",
    strokeWidth: 0.922222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12755_546338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 581,
    height: 304,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntityFound);
export default __webpack_public_path__ + "static/media/no-entity-found.6042a5cac4c4b8ae7245ba2c9d858228.svg";
export { ForwardRef as ReactComponent };